import { Colors } from '@oy/uicore';
import React from 'react';

import { IconButton, IconButtonColor, Tabs, Text } from '@oy/ui';
import classNames from 'classnames';
import { useRef } from 'react';
import { Steppers } from '../../../Components/Steppers';
import styles from './Header.module.css';

export enum HeaderTitleAlign {
  CENTER = 'headerTitleCenter',
  LEFT = 'headerTitleLeft',
}

export enum TabsAlign {
  CENTER = 'tabsAlignCenter',
  LEFT = 'tabsAlignLeft',
  RIGHT = 'tabsAlignRight',
}

export type CreationLayoutHeader = {
  children?: React.ReactNode;
  headerTitle?: React.ReactNode | string;
  headerTitleAlign?: HeaderTitleAlign;
  leftGrid?: React.ReactNode;
  rightGrid?: React.ReactNode;
  showStepper?: boolean;
  stepsName?: { label: string }[];
  currentStep?: number;
  showTab?: boolean;
  tabsName?: { label: string }[];
  currentTab?: number;
  onChangeTab?: (val: number) => void;
  tabsAlign?: TabsAlign;
  showClose?: boolean;
  onClose?: () => void;
};

const Header = ({
  children,
  headerTitle,
  headerTitleAlign = HeaderTitleAlign.CENTER,
  leftGrid,
  rightGrid,
  showStepper = false,
  stepsName = [],
  currentStep = 0,
  showTab = false,
  tabsName = [],
  currentTab = 0,
  onChangeTab,
  tabsAlign = TabsAlign.LEFT,
  showClose,
  onClose,
}: CreationLayoutHeader) => {
  const containerRef = useRef(null);
  return (
    <>
      <div className={classNames([styles.header, styles[headerTitleAlign]])}>
        <div className={styles.left}>{leftGrid}</div>
        <div className={styles.headerMain}>
          <div className={styles.left}>
            {showClose && (
              <>
                <IconButton
                  iconName="close"
                  onClick={onClose}
                  color={IconButtonColor.Primary}
                />
                <div className={styles.divider}> </div>
              </>
            )}
            <Text
              textStyle={Text.Style.HeadingSm}
              className={styles.headerText}
            >
              {headerTitle}
            </Text>
          </div>
          <div>{children}</div>
        </div>
        <div className={styles.right}>{rightGrid}</div>
      </div>
      {showStepper && (
        <div className={styles.stepContainer}>
          <div className={styles.steppersContainer} ref={containerRef}>
            <Steppers
              direction={Steppers.Direction.HORIZONTAL}
              activeIndex={currentStep}
              steps={stepsName}
              type={Steppers.Type.LINEAR}
              completedDotColor={Colors.GREEN100}
              variant={Steppers.Variant.MINIMAL}
              containerRef={containerRef}
            />
          </div>
        </div>
      )}
      {showTab && onChangeTab && (
        <div className={styles.tabContainer}>
          <div
            className={classNames([styles.tabsContainer, styles[tabsAlign]])}
          >
            <Tabs activeIndex={currentTab} onChange={onChangeTab}>
              {tabsName.map((tab, index) => (
                <Tabs.Tab label={tab.label} key={index} />
              ))}
            </Tabs>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
